<template>
    <div class="bg-white px-3 index">
        <div class="add_tits" ref="titles">
            <el-form class="form-inlines u-f u-jsb" :inline="true">
                <div>
                    <el-form-item label="状态">
                        <el-select v-model="lb_value" placeholder="请选择" clearable size="small" filterable>
                            <el-option v-for="item in  lb_options" :key="item.id" :label="item.text" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="兑换码">
                        <el-input v-model="dhm_value" placeholder="请输入兑换码" size="small"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="height" class="tableLimit">
                <el-table-column prop="code" label="兑换码" show-overflow-tooltip></el-table-column>

                <el-table-column prop="status" label="状态" show-overflow-tooltip width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status==1">已兑换</span>
                        <span v-else-if="scope.row.status==2">未兑换</span>
                    </template>
                </el-table-column>
                <el-table-column prop="real_name" label="用户" width="200">
                    <template slot-scope="{row}">
                        <div class="u-f u-ac">
                            <el-image style="width: 50px; height: 50px" :src="row.prizeUser.avatar" fit="cover">
                            </el-image>
                            <span>{{row.prizeUser.nickname}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="prize_time" label="兑换时间" width="180">

                </el-table-column>
                <el-table-column label="操作" width="100" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" v-if="scope.row.status==2" type="primary"
                            @click="handleEdit(scope.row,1)">兑换</el-button>
                        <el-button size="mini" v-else-if="scope.row.status==1" @click="handleEdit(scope.row,2)"
                            type="info">已兑换</el-button>
                        <!-- <el-button size="mini" type="primary" @click="detailbtn(scope.row,scope.$index)">详情</el-button> -->
                        <!-- <el-button size="mini" type="danger" @click="handleDelet(scope.row,scope.$index)">删除</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[10]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>
        </div>

    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    import tinymce from '@/components/common/tinymce.vue';
    export default {
        components: {
            tinymce,
        },
        data() {
            return {
                lb_value: '',
                lb_options: [{
                        id: 0,
                        text: '全部'
                    },
                    {
                        id: 1,
                        text: '已兑换'
                    },
                    {
                        id: 2,
                        text: '未兑换'
                    },
                ],

                ht_options: [],
                ht_options2: [],
                ry_options: [],
                loading: false,
                tableData: [],
                count: 0,
                currentPage: 1,
                pagesize: 10,
                height: null,
                // 
                eid: '0',
                dialogVisible: false,
                detaildialogVisible: false,
                subloading: false,
                dataId: '',
                listItem: [],

                ruleForm: {
                    lb_value: '',
                    keyword: '',
                    lb_dstime: '',
                    lb_put: 1,
                    lb_mapList: [],
                    kj_value: '',

                    ht_value: '',
                    ht_value2: '',
                    ry_value: '',
                    textarea: '',
                },
                getruleForm: {
                    rytext: '',
                    pltext: '',
                    ht_value2: '',
                    textarea: '',
                    kj_value: '',
                    lb_value: '',
                    images: '',
                    ry_value2: '',


                },
                zan: false,
                mapListed: [],
                rule: {
                    lb_value: [{
                        required: true,
                        message: '请选择类别',
                        trigger: 'blur'
                    }],
                    kj_value: [{
                        required: true,
                        message: '请选择谁可见',
                        trigger: 'blur'
                    }],

                    textarea: [{
                        required: true,
                        message: '请填写内容',
                        trigger: 'blur'
                    }],
                    ry_value: [{
                        required: true,
                        message: '请选择人员',
                        trigger: 'blur'
                    }],
                    ry_value2: [{
                        required: true,
                        message: '请选择人员',
                        trigger: 'blur'
                    }],
                    ht_value: [{
                        required: true,
                        message: '请选择话题类型',
                        trigger: 'blur'
                    }],
                    ht_value2: [{
                        required: true,
                        message: '请选择话题列表',
                        trigger: 'blur'
                    }],
                    keyword: [{
                        required: true,
                        message: '请填写关键词',
                        trigger: 'blur'
                    }],
                    lb_put: [{
                        required: true,
                        message: '请选择发布设置',
                        trigger: 'blur'
                    }],
                },
                // 
                dialog_prev: false,
                urls: '',
                topic_child_options: [],
                date: xaoi.date,
                dhm_value:'',

            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getHeight()
            this.getper()
            this.begin()

        },
        methods: {
            beforeUpload() {
                if (!this.ruleForm.ry_value) {
                    this.$message({
                        message: '请先选择人员哦',
                        type: 'warning'
                    });
                    return false
                }
            },
            getHeight() {
                let that = this
                var titles = that.$refs.titles.offsetHeight
                that.height = window.innerHeight - titles - 200 + 'px'
                window.onresize = () => {
                    var titles = that.$refs.titles.offsetHeight
                    that.height = window.innerHeight - titles - 200 + 'px'
                }
            },

            // 搜索
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 10
                that.search()
            },
            async search() {
                let that = this
                that.tableData = []
                that.loading = true
                let params = {
                    limit: this.pagecount,
                    page: this.page,
                    status: that.lb_value,
                    user_id: '',
                    source: 1,
                    code:this.dhm_value
                }
                this.axios.post('/admin/wssadmin/prizecode/PrizeCode', params, {
                    token: true
                }).then(res => {
                    that.loading = false
                    that.tableData = res.data.data.list
                    that.count = res.data.data.count
                })
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            handleAdd() {
                let that = this
                that.dialogVisible = true
                that.eid = ''
                that.form_clear()
            },
            form_clear() {
                let that = this
                that.ruleForm.lb_value = ''
                that.ruleForm.textarea = ''
                that.ruleForm.lb_mapList = []
                that.ruleForm.ry_value = ''
                that.mapListed = []
            },
            // 鼠标单击的事件
            onClick(e, editor) {},
            async submit(formName) {
                let that = this
                that.$refs[formName].validate(async (valid) => {
                    if (valid) {
                        let arr1 = []
                        let obj = {}
                        if (that.mapListed.length > 0) {
                            that.mapListed.forEach(ele => {
                                obj = {
                                    url: ele.url
                                }
                                arr1.push(obj)
                            })
                        }
                        that.subloading = true
                        let params = {
                            id: this.eid,
                            file: JSON.stringify(arr1),
                            content: that.ruleForm.textarea,
                            type_id: that.ruleForm.lb_value,
                            ry_value: that.ruleForm.ry_value
                        }
                        let res = await this.ajax('acadexchange/index/add', params)
                        if (res.code == 200) {
                            this.$message({
                                type: 'success',
                                message: '成功!'
                            });
                            that.dialogVisible = false
                            this.search()
                        } else {
                            that.$message.error(res.data.msg);
                        }
                        that.subloading = false
                    } else {
                        this.$alert("信息遗漏未填")
                        return false;
                    }
                });
            },
            //编辑
            async handleEdit(row, index) {
                let that = this
                this.$confirm(`确定把此兑换码改为${index==1?'已兑换':'未兑换'}吗, 是否继续?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    that.loading = true
                    this.axios.post('admin/wssadmin/prizecode/PrizeCodeStatus', {
                        id: row.id,
                        status: index,
                    }, {
                        token: true
                    }).then(res => {
                        that.loading = false
                        if (res.data.code == 200) {
                            this.$message({
                                type: 'success',
                                message: '修改成功!'
                            });
                            this.search()
                        } else {
                            this.$message({
                                type: 'info',
                                message: res.data.mag
                            });
                        }
                    })

                }).catch(() => {

                });


            },
            // 删除
            async handleDelet(row, index) {
                let that = this
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    let res = await this.ajax('acadexchange/index/del', {
                        id: row.id,
                        ry_value: row.create_user,
                    })
                    if (res.code == '200') {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        that.search()
                    } else {
                        that.$message.error(res.data.msg);
                    }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            gettimes() {
                let nowDate = new Date();
                let year = nowDate.getFullYear();
                let month = nowDate.getMonth() + 1;
                let day = nowDate.getDate();
                let hour = nowDate.getHours(); //获取系统时，
                let min = nowDate.getMinutes(); //分
                let sec = nowDate.getSeconds(); //秒
                month = month > 9 ? month : '0' + month
                day = day > 9 ? day : '0' + day
                hour = hour > 9 ? hour : '0' + hour
                min = min > 9 ? min : '0' + min
                sec = sec > 9 ? sec : '0' + sec
                return `${year}-${month}-${day} ${hour}:${min}`;
            },

            // 获取人员
            getper() {
                let that = this

                axios
                    .post(`/admin/getDoctorList`, {
                        page_count: 10000,
                        page: 1
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.ry_options = response.data.data.list
                    })
                    .catch(error => {})
            },
            uploadSuccess(response, file, fileList) {
                let that = this
                if (response.code == "201") {
                    that.$nextTick(() => {
                        let mainImg = that.$refs.upload;
                        if (mainImg) {
                            mainImg.uploadFiles.forEach((element, index) => {
                                if (file.uid == element.uid) {
                                    mainImg.uploadFiles.splice(index, 1)
                                }
                            });
                        }
                    })
                    that.$alert(response.msg)
                    return;
                }
                that.$message({
                    message: '上传成功',
                    type: 'success'
                });
                that.mapListed.push(response.data)
            },
            uploadRmove(file, fileList) {
                var index = this.mapListed.findIndex(item => item.id == file.id)
                this.mapListed.splice(index, 1)
            },

        },

    };
</script>


<style>
    .con_de {
        /* border: 1px solid red; */
        /* width: 200px; */
        width: 100%;
        max-height: 200px;
        overflow-y: scroll;
        line-height: 18px;
        position: relative;
        top: 7px;
        background-color: rgb(247, 245, 245);
        border-radius: 5px;
        padding: 5px;
    }

    .imgs {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        margin-right: 5px;
    }

    .lefts {
        max-height: 500px;
        overflow: auto;
    }

    .delt {
        color: red;
        font-size: 20px;
    }

    .blues {
        color: #409eff;
    }

    .concon {
        background: #f5f5f5;
        padding: 10px;
        border-radius: 10px;
    }

    .zanbtn {
        width: 30px;
        display: flex;
        /* border: 1px solid red; */
        cursor: pointer;
    }

    .zanbtn img {
        width: 100%;
        display: block;
    }

    .singleimg {
        width: 100px;
        width: 100px;
    }

    .singleimg img {
        width: 100%;
        height: 100%;
        display: block;
    }

    .imgbox {
        display: flex;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .tablimg {
        margin: 2px 5px;
    }
</style>